<template> 
<div class="uk-section" v-if="this.$store.getters.Loaded">


    <div  v-if="this.$store.getters.Loaded && avaliable">          
        <div class="uk-container">
            
            <div class="uk-margin ">
                <!---->
                    <div class="">
                        <div class="uk-container-center uk-text-center">
                            <input v-if="showName" class="uk-input uk-form-width-medium " type="text" v-model="name" placeholder="ФИО">
                            <input v-if="showEmail" class="uk-input uk-form-width-medium " type="text" v-model="email" placeholder="email">
                            <input v-if="showPhone" class="uk-input uk-form-width-medium " type="text" v-model="phone" placeholder="Телефон">
                            <input v-if="showSec" class="uk-input uk-form-width-medium " type="text" v-model="sec" placeholder="Секция">
                            <input v-if="showForm" class="uk-input uk-form-width-medium " type="text" v-model="form" placeholder="Участие"><br>                            
                            <input v-if="showDegree" class="uk-input uk-form-width-medium " type="text" v-model="degree" placeholder="Степень">                        
                            <input v-if="showCou" class="uk-input uk-form-width-medium " type="text" v-model="country" placeholder="Страна">
                            <input v-if="showCity" class="uk-input uk-form-width-medium " type="text" v-model="city" placeholder="Город">
                            <input v-if="showOrg" class="uk-input uk-form-width-medium " type="text" v-model="org" placeholder="Организация">
                            <input v-if="showPos" class="uk-input uk-form-width-medium " type="text" v-model="pos" placeholder="Должность"><br>
                            <!--input class="uk-input uk-form-width-medium " type="text" v-model="statusReport" placeholder="Статус доклада"-->
                            <select class="uk-select uk-form-width-medium" placeholder="" v-model="reports">
                                <option value="3" selected>Доклад</option>
                                <option value="1">Есть</option>
                                <option value="0">Нет</option>                               
                            </select><br>
                            <select v-if="reports==1" class="uk-select uk-form-width-medium" placeholder="Статус доклада" v-model="statusReport">
                                <option value=""  selected>Статус доклада</option>
                                <option value="Ревью">Ревью</option>
                                <option value="Подтверждён">Подтверждён</option>
                                <option value="Ожидает оплаты">Ожидает оплаты</option>
                                <option value="Требует изменений">Требует изменений</option>
                                <option value="Опубликовано">Опубликовано</option>
                                <option value="Отклонено">Отклонено</option>
                                <option value="В архиве">В архиве</option>
                            </select>
                            <!--input v-if="showBd" class="uk-input uk-form-width-medium " type="date" v-model="bd" placeholder="др"--><br>
                            <input v-if="showAcept" class="uk-checkbox " type="checkbox" v-model="acept" placeholder="Подтверждён"><label>Подтверждение</label><br>
                            
                            <input v-if="showAcept" class="uk-checkbox " type="checkbox" v-model="review" placeholder="Подтверждён"><label>Требует рецензирования</label><br>
                            <button class="uk-button uk-button-primary  uk-form-width-medium" @click="clearFilters">Очистить фильтры</button>
                        </div>
                    </div>
                    
                
                <div class="uk-height-large uk-overflow-auto uk-margin-bottom" >
                    
                <div  class="uk-border-rounded uk-card   uk-card-default uk-margin uk-animation-scale-down uk-align-center uk-margi-bottom" v-for="participant in filteredContacts" :key="generateKey(participant)">
                    <div uk-grid class="uk-child-width-expand@s uk-text-center uk-flex-between uk-text-break">
                        <div class="uk-width-1-6">
                            <input type="checkbox" class="uk-checkbox uk-form-success uk-margin-top " :value="participant.email" v-model="selectedEmails"><br>
                            <span>Выбрать</span>
                        </div>
                        
                        <div v-if="showName" class=""><span class="uk-text-muted uk-text-small">ФИО</span><br><span>{{ participant['ФИО']}}</span></div>
                        <div v-if="showEmail" class=""><span class="uk-text-muted uk-text-small">email</span><br><a :href="'mailto:'+participant.email">{{ participant.email }}</a></div>
                        <div v-if="showPhone" class=""><span class="uk-text-muted uk-text-small">phone</span><br><a :href="'tel:'+participant.Phone">{{ participant.Phone }}</a></div>
                        <div v-if="showSec" class=""><span class="uk-text-muted uk-text-small">Секция</span><br><span>{{ participant['Секция'] }}</span></div>
                        <div v-if="showForm" class=""><span class="uk-text-muted uk-text-small">Форма участия</span><br>{{ participant['Форма участия'] }}</div>
                        <div v-if="showAcept"  class=""><span class="uk-text-muted uk-text-small">Подтверждён</span><br><input type="checkbox" class="uk-checkbox" disabled :checked="participant['Подтверждён']"></div>
                    </div>
                    <div uk-grid  class="uk-accordion-content uk-child-width-expand@s uk-text-center uk-flex-between uk-text-break uk-margin-remove-top">                            
                        <div class="uk-width-1-6">                            
                            <a class="uk-button" uk-icon="icon: pencil" @click="edit(participant.id)"   title="Изменить"></a><br>
                            <span>Изменить</span>
                        </div>
                                <div v-if="showDegree" class=""><span class="uk-text-muted uk-text-small">Степень</span><br><span>{{ participant['Степень'] }}</span></div>
                                <div v-if="showCou" class=""><span class="uk-text-muted uk-text-small">Страна</span><br><span>{{ participant['Страна'] }}</span></div>
                                <div v-if="showCity" class=""><span class="uk-text-muted uk-text-small">Город</span><br><span>{{ participant['Город'] }}</span></div>
                                <div v-if="showOrg" class=""><span class="uk-text-muted uk-text-small">Организация</span><br><span>{{ participant['Организация'] }}</span></div>
                                <div v-if="showPos" class=""><span class="uk-text-muted uk-text-small">Должность</span><br><span>{{ participant['Должность'] }}</span></div>
                                <div v-if="showBd"  class=""><span class="uk-text-muted uk-text-small">Дата рождения</span><br><span>{{ participant['Дата рождения'] }}</span></div>
                    </div>                    
                    <ul ref="additional" uk-accordion="multiple: true" class="uk-margin-remove-top">
                         <li  :class="{ 'uk-open': oppenFiles }" >
                            <a v-if="participant.publication_id" class="uk-accordion-title uk-text-center" href="#"><span class="uk-text-primary uk-text-small">Доклад</span></a>
                            <div class="uk-accordion-content uk-text-center uk-flex-between uk-text-break">                            
                                <div class=""><span class="uk-text-muted uk-text-small">Название</span><br><span>{{ participant['Заголовок'] }}</span></div>
                                <div class=""><span class="uk-text-muted uk-text-small">Статус</span><br><span>{{ participant['Статус доклада'] }}</span></div>
                                <div v-if="participant['Соавторы']" class=""><span class="uk-text-muted uk-text-small">Соавторы</span><br><span>{{ participant['Соавторы'] }}</span></div>                                
                                <div class=""><span class="uk-text-muted uk-text-small">Последние изменения от</span><br>{{ participant['Последние обновление'] }}</div>

                                <div class=""><span class="uk-text-muted uk-text-small">Аннотация</span><br><span>{{ participant['Аннотация'] }}</span></div>
                                
                                <div v-if="participant['Файлы']">
                                <span class="uk-text-muted uk-text-small">Файлы</span>
                                <ul  class="uk-list"  v-for="file in participant['Файлы']" :key="file.name">
                                    <li><a :href="file.url">{{ file.name}}</a></li>
                                </ul>
                                
                                </div>
                                <div>
                                    <button class="uk-button uk-button-primary " @click="acceptReport(participant.publication_id,participant['Статус доклада'])">Изменить статус</button>   
                                </div>                                
                            </div>
                        </li>
                    </ul>                    
                </div>
               
                </div>
                <div class="uk-margin-bottom uk-margin-top uk-text-center">
                    <input type="checkbox" class="uk-checkbox" checked :value="1" v-model="showName"><label>ФИО</label>
                    <input type="checkbox" class="uk-checkbox" checked :value="1" v-model="showEmail"><label>email</label>
                    <input type="checkbox" class="uk-checkbox" checked :value="1" v-model="showPhone"><label>телефон</label>
                    <input type="checkbox" class="uk-checkbox" checked :value="1" v-model="showSec"><label>секции</label>
                    <input type="checkbox" class="uk-checkbox" checked :value="1" v-model="showForm"><label>форма</label>
                    <input type="checkbox" class="uk-checkbox" checked :value="1" v-model="showAcept"><label>подтверждение</label>
                    <input type="checkbox" class="uk-checkbox" checked :value="1" v-model="showDegree"><label>степень</label>
                    <input type="checkbox" class="uk-checkbox" checked :value="1" v-model="showCou"><label>страна</label>
                    <input type="checkbox" class="uk-checkbox" checked :value="1" v-model="showCity"><label>город</label>
                    <input type="checkbox" class="uk-checkbox" checked :value="1" v-model="showOrg"><label>орг</label>
                    <input type="checkbox" class="uk-checkbox" checked :value="1" v-model="showPos"><label>должность</label>
                    <input type="checkbox" class="uk-checkbox" checked :value="1" v-model="showBd"><label>др</label><br>     
                    
                    <button class="uk-button uk-button-primary  uk-width-medium uk-margin-right@m" @click="selectAllEmails">Выбрать всех</button>
                    <button class="uk-button uk-button-primary  uk-width-medium" @click="deselectAllEmails">Сбросить</button><br>
                    <button class="uk-button uk-button-primary  uk-width-medium uk-margin-left@m" @click="exportFile">Экспорт в xlsx с фильтрацией</button><br>
                    <button class="uk-button uk-button-primary  uk-width-medium uk-margin-left@m" @click="exportFileAll">Экспорт в xlsx все данные</button><br>
                    <!--button class="uk-button uk-button-primary  uk-width-medium" @click="exportFileAbstracts">Экспорт с данными о докладах</button-->
                    <span  class="uk-heading">Найдено участников: {{ filteredContacts.length }}</span><br>
                    <span  class="uk-heading">Выбрано получателей: {{ selectedEmails.length }}</span>
                </div>                                
            </div>
            
            <div class="uk-container uk-height-medium uk-align-center uk-margin-bottom uk-text-center">
                <input class="uk-input  uk-margin-top" type="text" v-model="selectedEmails" placeholder="Кому">
                <input class="uk-input  uk-margin-top uk-margin-bottom" type="text" v-model="subject" placeholder="Тема">
                
                <QuillEditor ref="myEditor" contentType="html" theme="snow" :toolbar="tollbarConfig" @change="updateMesage" v-model:content="emailMessage"/><br>
                <div id="error" v-if="message" class="uk-alert-danger" uk-alert>
                    <a class="uk-alert-close" uk-close v-on:click.stop.prevent="message=''"></a>
                    <p>{{message}}</p>
                </div> 
                
                <button v-if="!sending" class="uk-button uk-button-primary " @click="send">Отправить</button>
                
                <ul ref="additional" uk-accordion="multiple: true" class="uk-margin-top uk-margin-bottom">
                         <li class="uk-margin-bottom">
                            <a v-if="mailList" class="uk-accordion-title" href="#"><span class="uk-text-primary ">История сообщений</span></a>
                            <div class="uk-accordion-content  uk-text-break">                            
                            <!-- Email Lists-->
                            <div class="uk-height-large uk-overflow-auto uk-margin-bottom" >
                                <div  class="uk-border-rounded uk-card   uk-card-default uk-margin uk-animation-scale-down uk-align-center uk-margi-bottom" v-for="email in mailList" :key="email.id">
                                        <div uk-grid class="uk-text-center  uk-text-break">                        
                                            <div class="uk-width-1-3 uk-text-center">
                                                <div class=""><span class="uk-text-muted uk-text-small">Отправил</span><br><span>{{ userNames[email.author_id]}}</span></div>
                                                <div class=""><span class="uk-text-muted uk-text-small">Отправленно</span><br><span>{{ email.created_at }}</span></div> 
                                                <div class=""><span class="uk-text-muted uk-text-small">Тема</span><br><span>{{ email.title}}</span></div>
                                                <div class=""><span class="uk-text-muted uk-text-small">Получатели:</span><br><div class="uk-height-max-small uk-overflow-auto"><span>{{email.addressees}}</span></div></div>                                                
                                                <button class="uk-button uk-button-primary uk-margin-remove-top uk-button-small uk-form-width-medium" @click="retryMessage(email)">Вставить в редактор</button><br>
                                                <button class="uk-button uk-button-primary uk-margin-remove-top uk-button-small uk-form-width-medium" @click="updateMessage(email.message)">Вставить только текст</button>
                                            </div>
                                            <div class=" uk-width-2-3 uk-text-left">
                                                <div div class="uk-height-medium uk-overflow-auto"><span class="uk-text-muted uk-text-small">Текст</span><br><span v-html="email.message"></span></div>
                                            </div>
                                        </div>
                                </div>
                            </div>                            
                            </div>
                        </li>
                    </ul>    
                
            </div>
            
            </div>
            
             
        </div>
                    
        <div class="uk-flex-top modal-edit uk-position-z-index uk-margin-top" uk-modal>
        <div class="uk-border-rounded uk-modal-dialog uk-margin-auto-vertical uk-width-2-3@m uk-margin uk-align-center uk-margin-bottom">
            <button class="uk-modal-close-default" type="button" uk-close></button>
            <!---->                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   
            <div class="uk-child-width-expand@s uk-text-center " uk-grid>
            <!-- First -->
            <div>
            <!--Name-->
            <div class="uk-margin ">
                <label class="uk-form-label " for="form-stacked-text">{{ this.$store.getters.GetText.registration.name[this.$store.getters.Lang]}}</label><br>
                <div class="uk-inline uk-width-expand ">
                    <span class="uk-form-icon " uk-icon="icon: user"></span>
                    <input  v-model="user.name" class="uk-input  uk-text-center" type="text" aria-label="Not clickable icon" placeholder="" autocomplete="name">
                </div>
            </div>
            <!--Country-->
            <div class="uk-margin ">
                <label class="uk-form-label" for="form-stacked-text">{{ this.$store.getters.GetText.registration.country[this.$store.getters.Lang]}}</label><br>
                <div class="uk-inline uk-width-expand">
                    <span class="uk-form-icon " uk-icon="icon:  world"></span>
                    <input  v-model="user.country" class="uk-input  uk-text-center" type="text" aria-label="Not clickable icon" placeholder="" autocomplete="country-name">
                </div>
            </div>
            <!--Work-->
            <div class="uk-margin ">
                <label class="uk-form-label" for="form-stacked-text">{{ this.$store.getters.GetText.registration.work[this.$store.getters.Lang]}}</label><br>
                <div class="uk-inline uk-width-expand">
                    <span class="uk-form-icon " uk-icon="icon: users"></span>
                    <input  v-model="user.work" class="uk-input  uk-text-center" type="text" aria-label="Not clickable icon" placeholder="" autocomplete="organization" name="work">
                </div>
            </div>
            <!--Phone-->
            <div class="uk-margin ">
                <label class="uk-form-label" for="form-stacked-text">{{ this.$store.getters.GetText.registration.phone[this.$store.getters.Lang]}}</label><br>
                <div class="uk-inline uk-width-expand">
                    <span class="uk-form-icon " uk-icon="icon: phone"></span>
                    <input   v-model="user.phone" class="uk-input  uk-text-center" type="tel" aria-label="Not clickable icon" placeholder="" autocomplete="tel">
                </div>
            </div>
            <!--Section-->
            <div class="uk-margin ">
                <label class="uk-form-label" for="form-stacked-text">{{ this.$store.getters.GetText.registration.section[this.$store.getters.Lang]}}</label><br>
                <div class="uk-inline uk-width-expand">
                    <span class="uk-form-icon " ></span>                    
                    <select  v-model="user.section" class="uk-select uk-text-center" aria-label="{{ this.$store.getters.GetText.registration.section[this.$store.getters.Lang]}}">
                        <option  v-for="sect in this.$store.getters.Sections" :value="sect.id" :key="sect.id">{{ sect[this.$store.getters.Lang] }}</option>
                    </select>
                </div>
            </div>
            <div class="uk-margin ">
                <label class="uk-form-label " for="form-stacked-text">Email</label><br>
                <div class="uk-inline uk-width-expand ">                    
                    <input  v-model="user.email" class="uk-input  uk-text-center" @input="checkEmail()" type="text" aria-label="Not clickable icon" placeholder="Email"><br>
                    <span class="uk-form-label uk-text-warning uk-text-meta">Заполнение поля приведёт к смене почтового адреса пользователя!</span>
                </div>
            </div> 
            
            </div>
            <!-- Second -->
            <div>
            <!--BD-->
            <div class="uk-margin ">
                <label class="uk-form-label" for="form-stacked-text">{{this.$store.getters.GetText.registration.birt[this.$store.getters.Lang]}}</label><br>
                    <div class="uk-inline uk-width-expand">
                    <span class="uk-form-icon " uk-icon="icon: calendar"></span>
                    <input  v-model="user.birthday" class="uk-input  uk-text-center" type="date" aria-label="Not clickable icon" placeholder="" name="bday" autocomplete="bday">
                </div>
            </div>
            <!--City-->     
            <div class="uk-margin ">
            <label class="uk-form-label" for="form-stacked-text">{{this.$store.getters.GetText.registration.city[this.$store.getters.Lang]}}</label><br>
                <div class="uk-inline uk-width-expand">
                    <span class="uk-form-icon " uk-icon="icon: home"></span>
                    <input  v-model="user.city" class="uk-input  uk-text-center" type="text" aria-label="Not clickable icon" placeholder="" autocomplete="address-level1" name="city">
                </div>
            </div>
            <!--Position-->
            <div class="uk-margin ">
                <label class="uk-form-label" for="form-stacked-text">{{this.$store.getters.GetText.registration.position[this.$store.getters.Lang]}}</label><br>
                <div class="uk-inline uk-width-expand">
                    <span class="uk-form-icon " uk-icon="icon: linkedin"></span>
                    <input  v-model="user.position" class="uk-input  uk-text-center" type="text" aria-label="Not clickable icon" placeholder="" autocomplete="on" name="organization-title">
              </div>
            </div>
            <!--Degree-->
            <div class="uk-margin ">
                <label class="uk-form-label" for="form-stacked-text">{{ this.$store.getters.GetText.registration.degree[this.$store.getters.Lang]}}</label><br>
                <div class="uk-inline uk-width-expand">
                    <span class="uk-form-icon " uk-icon="icon: bolt"></span>
                    <select  v-model="user.degree" class="uk-select uk-text-center " aria-label="{{this.$store.getters.GetText.registration.form[this.$store.getters.Lang]}}">            
                        <option class="uk-text-center" v-for="(degrees, index) in degree_list[this.$store.getters.Lang]" :key="index" :value="index">
                            {{degrees}}
                        </option>
                    </select>
                </div>
            </div>
            <!--Form-->    
            <div class="uk-margin ">
                <label class="uk-form-label" for="form-stacked-text">{{this.$store.getters.GetText.registration.form[this.$store.getters.Lang]}}</label><br>
                <div class="uk-inline uk-width-expand">
                    <span class="uk-form-icon " ></span>                    
                    <select  v-model="user.form" class="uk-select uk-text-center" aria-label="{{this.$store.getters.GetText.registration.form[this.$store.getters.Lang]}}">
                            <option>Offline</option>
                            <option>Online</option>
                    </select>
                </div>
            </div>        
            <div class="uk-margin ">
                <label class="uk-form-label " for="form-stacked-text">Пароль</label><br>
                <div class="uk-inline uk-width-expand ">                    
                    <input  v-model="user.password" class="uk-input  uk-text-center" type="text" aria-label="Not clickable icon" placeholder="Пароль"><br>
                    <span class="uk-form-label uk-text-warning uk-text-meta">Заполнение поля приведёт к смене пароля пользователя!</span>
                </div>
            </div>
            
            

            
            </div>
            <br>
                         
        </div>
        <div class="uk-margin uk-text-center">                
                <div class="uk-inline uk-width-expand ">    
                    <label class="uk-form-label ">Подтверждение участия</label><br>                
                    <input type="checkbox" class="uk-checkbox uk-form-success uk-margin-top " :checked="user.acept" v-model="user.acept">                    
                </div>
        </div>
        <div class="uk-child-width-expand@s uk-text-center " uk-grid>
        <div><button v-if="email_verify" class="uk-button uk-button-primary  uk-width-expand uk-width-1-3 uk-align-center" v-on:click="update()" >{{this.$store.getters.GetText.personal.save[this.$store.getters.Lang]}}</button></div>
        <div><button class="uk-button uk-button-danger  uk-width-expand uk-width-1-3 uk-align-center" v-on:click="cancel()">{{this.$store.getters.GetText.personal.cancel[this.$store.getters.Lang]}}</button></div>
        </div>
        </div>
        </div>


    
</div>
</template>
    <script>    
    import { utils,writeFileXLSX  } from 'xlsx';
    //import router from 'vue-router'
    import { QuillEditor } from '@vueup/vue-quill'
    import '@vueup/vue-quill/dist/vue-quill.snow.css'    
    import UIkit from 'uikit'
    import api from '@/api'
    //import axios from 'axios';
    export default {
        name: "LoginForm",
        components: {
            QuillEditor
        },
        data(){
            return{
                user:{ id:'',name:'', country:'', work:'', phone:'', section:'', birthday:'', city:'', position:'', degree:'', form:'', password:'' ,email:'',acept:false},
                degree_list:{
                    Ru:{1:'Student',2:'Master',3:'Postgraduate',4:'Candidate',5:'Doctor',6:'Corresponding Member',7:'Academician',8:'PHD'},
                    En:{1:'Студент',2:'Магистрант',3:'Аспирант',4:'Кандидат наук',5:'Доктор наук',6:'Член-корреспондент РАН',7:'Академик РАН',8:'PHD'}
                }, 
                degree_stat:[{'id':1,val:'Студент'},{'id':2,'val':'Магистрант'},{'id':3,'val':'Аспирант'},{'id':4,'val':'Кандидат наук'},{'id':5,'val':'Доктор наук'},{'id':6,'val':'Член-корреспондент РАН'},{'id':7,'val':'Академик РАН'},{'id':8,'val':'PHD'}],
                sending: false,
                review: false,
                oppenFiles: false,
                avaliable: false,
                reports: '3',
                name:'',
                email:'',
                emailOld:'',
                email_verify:true,
                mailList:[],
                phone:'',
                acept:true,
                sec:'',
                form:'',
                degree:'',
                selDegree:[],
                selCountry:[],
                selCity:[],
                selOrg:[],
                selPos:[],
                country:'',
                city:'',
                org:'',
                pos:'',
                bd:'',
                statusReport:'',
                showName:true,
                showEmail:true,
                showPhone:true,
                showSec:true,
                showForm:true,
                showAcept:true,
                showDegree:true,
                showCou:true,
                showCity:true,
                showOrg:true,
                showPos:true,
                showBd:true,
                contacts:[],
                selectedEmails:[],
                selectedID:[], 
                emailMessage:'',                
                subject:'',
                editor: null,
                search:'',                
                message:'',
                userNames:{},
                tollbarConfig:[
                              ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
                              ['blockquote', 'code-block','link','image'],

                              [{ 'header': 1 }, { 'header': 2 }],               // custom button values
                              [{ 'header': [1, 2, 3, 4, 5, 6, false] }],        // custom dropdown
                              [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                              [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
                              [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
                              [{ 'direction': 'rtl' }],                         // text direction
                             

                               
                              

                              [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
                              [{ 'font': [] }],
                              [{ 'align': [] }],
                              //[{'emoji-toolbar': true}],
                              ['clean']                                         // remove formatting button
                            ]

            }
        },
        computed: {
            filteredContacts () {
                const list = this.contacts.filter(participant => { 
                    switch(this.reports) {
                        case '3': 
                            return participant && 
                            participant['ФИО'].toLowerCase().includes(this.name.toLowerCase()) &&
                            participant['email'].toLowerCase().includes(this.email.toLowerCase()) &&
                            participant['Phone'].toLowerCase().includes(this.phone.toLowerCase()) &&
                            participant['Секция'].toLowerCase().includes(this.sec.toLowerCase()) &&
                            participant['Форма участия'].toLowerCase().includes(this.form.toLowerCase()) &&
                            (participant['Подтверждён']==this.acept) &&
                            (participant['review']==this.review) &&
                            participant['Степень'].toLowerCase().includes(this.degree.toLowerCase()) &&
                            participant['Страна'].toLowerCase().includes(this.country.toLowerCase()) &&
                            participant['Город'].toLowerCase().includes(this.city.toLowerCase()) &&
                            participant['Организация'].toLowerCase().includes(this.org.toLowerCase()) &&
                            participant['Должность'].toLowerCase().includes(this.pos.toLowerCase()) &&
                            participant['Статус доклада'].toLowerCase().includes(this.statusReport.toLowerCase()) &&                    
                            participant['Дата рождения'].toLowerCase().includes(this.bd.toLowerCase());
                        case '1': 
                            return participant.reports === true && 
                            participant['ФИО'].toLowerCase().includes(this.name.toLowerCase()) &&
                            participant['email'].toLowerCase().includes(this.email.toLowerCase()) &&
                            participant['Phone'].toLowerCase().includes(this.phone.toLowerCase()) &&
                            participant['Секция'].toLowerCase().includes(this.sec.toLowerCase()) &&
                            participant['Форма участия'].toLowerCase().includes(this.form.toLowerCase()) &&
                            (participant['Подтверждён']==this.acept) &&
                            (participant['review']==this.review) &&
                            participant['Степень'].toLowerCase().includes(this.degree.toLowerCase()) &&
                            participant['Страна'].toLowerCase().includes(this.country.toLowerCase()) &&
                            participant['Город'].toLowerCase().includes(this.city.toLowerCase()) &&
                            participant['Организация'].toLowerCase().includes(this.org.toLowerCase()) &&
                            participant['Должность'].toLowerCase().includes(this.pos.toLowerCase()) &&
                            participant['Статус доклада'].toLowerCase().includes(this.statusReport.toLowerCase()) &&                    
                            participant['Дата рождения'].toLowerCase().includes(this.bd.toLowerCase());
                        case '0':
                            return participant.reports === false && 
                            participant['ФИО'].toLowerCase().includes(this.name.toLowerCase()) &&
                            participant['email'].toLowerCase().includes(this.email.toLowerCase()) &&
                            participant['Phone'].toLowerCase().includes(this.phone.toLowerCase()) &&
                            participant['Секция'].toLowerCase().includes(this.sec.toLowerCase()) &&
                            participant['Форма участия'].toLowerCase().includes(this.form.toLowerCase()) &&
                            (participant['Подтверждён']==this.acept) &&
                            (participant['review']==this.review) &&
                            participant['Степень'].toLowerCase().includes(this.degree.toLowerCase()) &&
                            participant['Страна'].toLowerCase().includes(this.country.toLowerCase()) &&
                            participant['Город'].toLowerCase().includes(this.city.toLowerCase()) &&
                            participant['Организация'].toLowerCase().includes(this.org.toLowerCase()) &&
                            participant['Должность'].toLowerCase().includes(this.pos.toLowerCase()) &&
                            participant['Статус доклада'].toLowerCase().includes(this.statusReport.toLowerCase()) &&                    
                            participant['Дата рождения'].toLowerCase().includes(this.bd.toLowerCase()); 
                    }         
                });
                return list;
            }  
        },
        mounted(){
            this.getContacts()
            this.getMails()
            this.addSelects()
            this.emailMessage='<p></p><p>_________________________________________</p><p>С наилучшими пожеланиями, Оргкомитет конференции.</p>'
            //this.emailMessage = [
            //  { insert: '_________________________________________' },              
            //  { insert: '\n' },
            //  { insert: 'С наилучшими пожеланиями, Оргкомитет конференции.' },
            //];           
            
            
        },
        beforeUnmount() {
            //this.editor.destroy()
        },
        methods:{
            updateMessage(message){
                this.emailMessage=message
            },
            updateMesage(content) {                
                this.emailMessage = content;                
            },
            retryMessage(email){
                this.selectedEmails=email.addressees.replaceAll(';', ',')
                this.subject=email.title
                this.emailMessage=email.message
            },
            generateKey(participant) {
                return `${participant.id}-${participant.publication_id}`
            },
            checkEmail(){
                if (this.emailOld!=this.user.email){
                    var $this = this
                    this.email_verify=true                    
                    api.post('/api/auth/check',
                    {email: this.user.email}).then(
                        res=>{
                            //console.log(res.data)
                            if (res.data.message!='ok'){
                                $this.email_verify=false
                                UIkit.notification({message: '<span ></span>Указанные адрес занят!!',status:'danger',pos: 'bottom-center'})
                            } else {
                                $this.email_verify=true
                            }
                        }
                    )
                } else {
                    this.email_verify=true  
                }
            },
            setUser(id){
                this.contacts.forEach(user=>{
                    if (user.id==id){
                        this.$store.getters.Sections.forEach(section=>{
                            if (section.En==user['Секция']){
                                this.user.section=section.id
                            }
                        })
                        
                        
                        this.degree_stat.forEach(deg=>{
                            if (deg.val==user['Степень']){
                                this.user.degree=deg.id.toString()
                            }
                        })                                            
                            
                        this.user.acept=user['Подтверждён']
                        this.user.id=id
                        this.user.name=user['ФИО']
                        this.user.email=user['email']
                        this.emailOld=user['email']
                        this.user.country=user['Страна']
                        this.user.work=user['Организация']
                        this.user.phone=user['Phone']                        
                        this.user.birthday=user['Дата рождения']
                        this.user.city=user['Город']
                        this.user.position=user['Должность']                        
                        this.user.form=user['Форма участия']         
                    }
                })
            },
            pushUser(){
                this.contacts.forEach(user=>{
                    if (this.user.id===user.id){
                        user['Подтверждён']=this.user.acept
                        user['ФИО']=this.user.name
                        user['email']=this.user.email
                        user['Страна']=this.user.country
                        user['Организация']=this.user.work
                        user['Phone']=this.user.phone
                        user['Дата рождения']=this.user.birthday
                        user['Город']=this.user.city
                        user['Должность']=this.user.position
                        user['Форма участия']=this.user.form                        
                        user['Степень']=this.degree_list.En[this.user.degree]
                        this.$store.getters.Sections.forEach(section=>{
                            if (section.id==this.user.section){
                                user['Секция']=section.En
                            }
                        })
                    }
                })
            },

            edit(id){      
                this.setUser(id)                          
                UIkit.modal(document.getElementsByClassName('modal-edit')).show();    
            },            
            update(){                
                this.user.lang=localStorage.getItem('localization')=='En'?'Ru':'En'      
                if(this.user.password.length===0){
                    delete this.user.password
                }  
                this.user.acept=Number(this.user.acept)
                //console.log(this.user)             
                var $this = this
                //$this.$store.commit('SET_Loaded',false)            
                api.post('api/auth/user/update',
                this.user).
                then(res=>{
                    //console.log(res.data)
                  if (res.data.message=='ok'){
                    UIkit.notification({message: '<span ></span>Успешно обновлено',status:'success'})                 
                    $this.cancel()
                    $this.pushUser()
                    $this.user={ id:'',name:'', country:'', work:'', phone:'', section:'', birthday:'', city:'', position:'', degree:'', form:'', password:'' ,email:'',acept:false}
                  } else {
                    UIkit.notification({message: '<span ></span>Не обновленно!',status:'danger',pos: 'bottom-center'}) 
                  }
                }
                ).catch(function(){
                    UIkit.notification({message: '<span ></span>Не обновленно!',status:'danger',pos: 'bottom-center'}) 
                }
            
                )
            
            },
            cancel(){
                UIkit.modal(document.getElementsByClassName('modal-edit')).hide();
            },
            getCurrentDate() {
                var currentDate = new Date();

                var day = currentDate.getDate();
                var month = currentDate.getMonth() + 1; // Months are zero-based
                var year = currentDate.getFullYear();

                // Pad single-digit day and month with leading zeros
                day = day < 10 ? '0' + day : day;
                month = month < 10 ? '0' + month : month;

                var formattedDate = day + '.' + month + '.' + year;
                return formattedDate;
            },
            clearFilters(){
                this.reports='3'
                this.name=''
                this.email=''
                this.phone=''
                this.acept=true
                this.sec=''
                this.form=''
                this.degree=''
                this.country=''
                this.city=''
                this.org=''
                this.pos=''
                this.bd=''
                this.statusReport=''
            },

            exportFile() {
                const ws = utils.json_to_sheet(this.filteredContacts);
                const wb = utils.book_new();
                utils.book_append_sheet(wb, ws, "Участники");
                let fileName="Участники_ptep_"+this.getCurrentDate().toString()+".xlsx"
                writeFileXLSX(wb,fileName );
            },
            exportFileAll() {
                const ws = utils.json_to_sheet(this.contacts);
                const wb = utils.book_new();
                utils.book_append_sheet(wb, ws, "Участники");
                let fileName="Участники_ptep_all_"+this.getCurrentDate().toString()+".xlsx"
                writeFileXLSX(wb,fileName );
            },
            exportFileAbstracts(){
                var $this= this
                this.selectedID=[]
                if (this.filteredContacts.length!=0){
                    this.filteredContacts.forEach(contact=>{                    
                    this.selectedID.push(contact.id)
                })   
                //console.log(this.selectedID)
                api.post('/api/auth/adminconfs',
                {
                    ids: this.selectedID,                    
                },{
                'authorization': `Bearer ${localStorage.getItem('access_token')}`,
                'X-Header-token-api': "bQAVWhAHRwGJQtGcP4hQtKQ68GZTHXVJpfCBjSuuFTNzZvnW"
                }
                ).then(
                    result=>{
                        //console.log(result.data)
                        const user = utils.json_to_sheet($this.filteredContacts);
                        const article = utils.json_to_sheet(result.data);
                        const wb = utils.book_new();
                        utils.book_append_sheet(wb, user, "Участники");
                        utils.book_append_sheet(wb, article, "Доклады");
                        writeFileXLSX(wb, "Участники_с_докладами_ptep.xlsx");
                        //$this.contacts = result.data
                        //$this.avaliable=true                               
                        //$this.$store.commit('SET_Loaded',true)                    
                        //localStorage.access_token=result.data.access_token
                        //$this.$router.push({name:'personal'})
                    }
                ).catch(function(error) {error});



                } else {
                    UIkit.notification({message: '<span ></span>Не выбранны данные для экспорта!',status:'danger',pos: 'bottom-center'}) 
                }
                
            },
            acceptReport(id,status){
                //console.log(id)
                var $this=this
                var status_list=[
                    {value: 1,Label:'Ревью'},
                    {value: 2,Label:'Подтверждён'},
                    {value: 3,Label:'Ожидает оплаты'},
                    {value: 4,Label:'Требует изменений'},
                    {value: 5,Label:'Опубликовано'},
                    {value: 6,Label:'Отклонено'},
                    {value: 7,Label:'В архиве'}
                ]
                var status_list_old = {1:'Ревью',2:'Подтверждён',3:'Ожидает оплаты',4:'Требует изменений',5:'Опубликовано',6:'Отклонено',7:'В архиве'}
                UIkit.modal.confirm('Выберите статус:<br><select id="selectInput" class="uk-select">' +
                    status_list.map(function (status_list) {
                        if (status==status_list.Label){
                            return '<option selected value="' + status_list.value + '">' + status_list.Label + '</option>';
                        } else {
                            return '<option value="' + status_list.value + '">' + status_list.Label + '</option>';
                        }
                    
                  }).join('') +
                  '</select>').then(function (result) {
                  if (result !== null) {
                    var selectedValue = document.getElementById('selectInput').value;
                    //console.log('Selected Option:', selectedValue);
                    api.post('api/auth/abstract/update/status',
                    {
                        id: id, 
                        status: selectedValue                                          
                    }).then(response=>{
                        response                        
                        UIkit.notification({message: '<span ></span>Успешно обновлено',status:'success'}) 
                        $this.contacts.forEach(contact=>{
                            contact['Статус доклада']=contact.publication_id==id?status_list_old[selectedValue]:contact['Статус доклада']
                            contact.review=selectedValue==1?1:0
                        })
                        //console.log(id)
                    }).catch(error=>{
                        error
                        UIkit.notification({message: '<span ></span>Не удалось обновить',status:'danger'})   
                    });
                    


                    
                  } 
                });  


            },
            send(){
                var $this=this
                this.message=''
                UIkit.notification({message: '<div class=" uk-text-center uk-height-small uk-width-small uk-flex-center uk-flex-middle uk-background-cover" data-src="img/loader.gif" uk-img></div>',status:'danger',pos: 'bottom-center'})
                if (this.selectedEmails.length>0 && this.subject.length>0 && this.emailMessage.length>0){
                    if (typeof(this.selectedEmails)=='string'){
                        this.selectedEmails=this.selectedEmails.split(',')
                    }
                    this.sending=true
                    //console.log(this.selectedEmails)
                    //console.log(this.subject)
                    //console.log(this.emailMessage)
                    api.post('/api/auth/mail/send',
                    {
                        to: this.selectedEmails, 
                        sub: this.subject,
                        msg: this.emailMessage                   
                    }).then(response=>{
                        response
                        //console.log(response.data)
                        UIkit.notification.closeAll()
                        UIkit.notification({message: '<span ></span>Успешно отправленно',status:'success',pos: 'bottom-center'}) 
                        $this.sending=false
                    }).catch(error=>{
                        error
                        UIkit.notification({message: '<span ></span>Не удалось отправить',status:'danger',pos: 'bottom-center'}) 
                        $this.sending=false  
                    })  
                } else {
                    UIkit.notification({message: '<span ></span>Заполните все поля',status:'danger',pos: 'bottom-center'})                    
                }
                
            },
            addSelects(){
                this.contacts.forEach(contact=>{                    
                this.selDegree.indexOf(contact['Степень'])==-1? this.selDegree.push(contact['Степень']):''
                this.selCountry.indexOf(contact['Страна'])==-1? this.selCountry.push(contact['Страна']):''
                this.selCity.indexOf(contact['Город'])==-1? this.selCity.push(contact['Город']):''
                this.selOrg.indexOf(contact['Организация'])==-1? this.selOrg.push(contact['Организация']):''
                this.selPos.indexOf(contact['Должность'])==-1? this.selPos.push(contact['Должность']):''
                })
            },
            deselectAllEmails(){
                this.selectedEmails=[]
            },
            selectAllEmails(){
                this.filteredContacts.forEach(contact=>{                    
                    this.selectedEmails.push(contact.email)
                })                
            },
            logout(){
            var $this=this
            this.$store.commit('SET_Loaded',false)
            api.post('api/auth/logout').then(res=>{
            if (res.status==200){
                localStorage.removeItem('access_token')
                this.$router.push({name:'home'})
                $this.$store.commit('SET_Loaded',true)
                $this.$store.commit('SET_ACCESS_DIR',false)
            }
            }) 
        },
        getMails(){
            var $this= this
                api.post('/api/auth/mail/get'              
                ).then(result=>{                    
                    console.log(result.data)
                    $this.mailList=result.data
                }).catch(error=>{
                    error
                })
        },
            getContacts(){                             
                this.message=''                
                const config = {
                    headers: { Authorization: `Bearer ${localStorage.getItem('access_token')}` }
                };
                var $this= this
                api.post('/api/auth/adminconfs/get','',config                
                ).then(
                    result=>{
                        var users=[]
                        result.data.forEach(user=>{
                            if (user['Статус доклада']===null){
                                user['Статус доклада']=""
                                user.reports=false
                            } else {
                                user.reports=true
                            }
                            $this.userNames[user.id]=user['ФИО']
                            if (user['Файлы']){
                                let files=[]                               
                                user['Файлы'].split(/\r\n/).forEach(file=>{
                                    //console.log(file);
                                    let file_parse=file.split(' ')[1].split('_')
                                    file_parse.shift()
                                    files.push({'name':file_parse.join('_'),'url':file})
                                })
                                user['Файлы']=files                                
                            }
                            //user['Файлы']=user['Файлы']?user['Файлы'].split(/\r\n/):null
                            users.push(user)
                        })
                        //console.log(users)
                        $this.contacts = result.data
                        $this.avaliable=true       
                        //console.log(result.data)                        
                        //$this.$store.commit('SET_Loaded',true)                    
                        //localStorage.access_token=result.data.access_token
                        //$this.$router.push({name:'personal'})
                    }
                ).catch((error) => {
                    console.log(error)
                        //$this.login()
                        if (error.response) {                             
                            if (error.response.status==401){
                                $this.message='Не авторизовано'
                                this.$router.push('login')
                            } else {
                                
                                $this.message='Данное действие не доступно!!!'
                                UIkit.notification({message: '<span ></span>Данное действие не доступно!!!',status:'danger',pos: 'bottom-center'})
                                this.$router.push('home')                                 
                            }
                        } else if (error.request) {
                            
                            $this.message='Данное действие не доступно!!!'
                            UIkit.notification({message: '<span ></span>Данное действие не доступно!!!',status:'danger',pos: 'bottom-center'})
                            this.$router.push('home')
                        } else {
                            $this.message='Данное действие не доступно!!!!'
                            UIkit.notification({message: '<span ></span>Данное действие не доступно!!!!',status:'danger',pos: 'bottom-center'})
                            this.$router.push('home')
                        }
    
                    })
                $this.avaliable=true
                
            }

        }        
    }
    </script>
